(function( $, moment ) {
    "use strict";

    var Event = require('./_events.js');
    var Tooltip = require('./_tooltip.js');
    var PreviewCalendarEvent = new Event();

    var PreviewCalendar = {
        data: null,

        setData: function(data) {
            PreviewCalendar.data = data || {};
        },

        onRefreshCalendar: function(ev) {
            var $calendar = $(this),
                view = $calendar.fullCalendar('getView'),
                start = view.start.clone(),
                end = view.end.clone().add(5, 'days');

            var calendarData = [
                {name: 'calendars', value: $calendar.data('preview-calendar.calendar')},
                {name: 'start', value: start.toISOString()},
                {name: 'end', value: end.clone().add(5, 'days').toISOString()}
            ];

            $calendar.addClass('ajax-loading');

            // Feed Request
            $.App.api('GET', 'calendar-view/event-sources', calendarData)
                .done(function(response) {
                    if (! response.success) {
                        // console.log('backend error');
                        return;
                    }

                    $calendar.fullCalendar('removeEventSources');

                    $.each(response.eventSources, function() {
                        $calendar.fullCalendar('addEventSource', this);
                    });

                    // Something is really slow here
                    PreviewCalendar.setData({
                        start: start,
                        end: end,
                        eventSources: response.eventSources
                    });
                })
                .always(function() {
                    $calendar.removeClass('ajax-loading');
                });
        },

        onRenderEvent: function(ev, event, element, view)
        {
            PreviewCalendarEvent.render(event, element, view);
        },

        onSelectEvent: function(ev, event, jsEvent, view)
        {
            window.CalendarTooltip.render(event, $(this), jsEvent);
        }
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $calendar = $container.find('[preview-calendar-calendar]');

        $calendar
            .on('refresh.pc.calendar', PreviewCalendar.onRefreshCalendar)
            .on('render.pc.event', PreviewCalendar.onRenderEvent)
            .on('select.pc.event', PreviewCalendar.onSelectEvent);

        var date = moment('19800101', 'YYYYMMDD');

        $calendar.fullCalendar({
            height: 870,
            aspectRatio: 1.75,
            editable: false,
            eventLimit: 3,
            scrollTime: '10:00',
            titleFormat: 'DD MMMM YYYY',
            slotLabelFormat: 'h(:mm)a',
            listDayFormat: 'dddd DD MMMM YYYY',
            listDayAltFormat: '',
            displayEventTime: false,
            defaultTimedEventDuration: '00:30:00',
            defaultDate : date,
            defaultView : 'agendaDay',
            header: {
                left: '',
                center: 'title',
                right: ''
            },
            views: {
                agendaTwoDay: {
                    type: 'agenda',
                    duration: { days: 2 }
                }
            },
            viewRender : function() {
                if (! $calendar.data('preview-calendar.view.booted')) {
                    $calendar.parent().addClass('hidden').removeClass('invisible');
                    return $calendar.data('preview-calendar.view.booted', true);
                }

                $calendar.trigger('refresh.pc.calendar');
            },
            eventRender: function(event, element, view) {
                $calendar.trigger('render.pc.event', [event, element, view]);
            },
            eventClick: function (event, jsEvent, view) {
                $calendar.trigger('select.pc.event', [event, jsEvent, view]);
            }
        });

        // Conflict Groups
        var $conflictGroupButtons = $container.find('[data-conflictgroup] button'),
            $previewCalendar = $calendar.parent(),
            $calendarOverlay = $previewCalendar.find('[preview-calendar-overlay]');

        $conflictGroupButtons.on('click', function(ev) {
            var $button = $(this),
                $conflictGroup = $button.closest('[data-conflictgroup]'),
                conflictData = $conflictGroup.data('conflictgroup'),
                start = moment(conflictData.start),
                end = moment(conflictData.end).subtract(1, 'second'),
                overlapDays = end.clone().startOf('day').diff(start.clone().startOf('day'), 'days'),
                view = overlapDays > 0 ? 'agendaTwoDay' : 'agendaDay';

            $calendar.parent().removeClass('hidden');

            $calendar.data('preview-calendar.calendar', conflictData.calendar);

            $calendar.fullCalendar('changeView', view, start);

            $calendar.offset({ top: ev.pageY - $calendar.height() / 2, left: ev.pageX + 50});
        });

        $calendarOverlay.on('click', function(ev) {
            $previewCalendar.addClass('hidden');
        })
    });

}( require('jquery'), require('moment'), require('fullcalendar') ));
